import { AppApiGatewayService } from './appApiGatewayService';
import { ApiGatewayFactory, AppServiceConfig } from './apiGatewayFactory';
import { AI_PLAYGROUND_CONFIGS } from './serviceConfig';

class ServiceManager {
  private static instance: ServiceManager;
  private services: AppApiGatewayService | null = null;

  private constructor() { }

  static async getInstance(): Promise<ServiceManager> {
    if (!ServiceManager.instance) {
      const instance = new ServiceManager();
      instance.services = await ApiGatewayFactory.createService(AI_PLAYGROUND_CONFIGS);
      ServiceManager.instance = instance;
    }
    return ServiceManager.instance;
  }

  getService(): AppApiGatewayService | null {
    return this.services;
  }

  clear(): void {
    this.services = null;
  }
}

export default ServiceManager.getInstance();